import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute } from '@angular/router';

import { TranService, PrInTransaction, TranType } from '../../services/tran.service';
import { WarehouseService } from '../../services/warehouse.service';
import { InAndOutService } from '../../services/in-and-out.service';
import { ProductCmpaService } from '../../services/product-cmpa.service';
import { ProductVntaService } from '../../services/product-vnta.service';

import { Observable } from 'rxjs/Observable';
import { Utils } from '../../util';
import { JsonPipe } from '@angular/common/src/pipes';
import { Subscription } from 'rxjs';
import { ProductionOrderService } from '../../services/production-order.service';
import { CatalogsSettingsService, Folios, PayrollId } from '../../services/catalogs-settings.service';
import { UnitService, UnitId } from '../../services/unit.service';

@Component({
  selector: 'app-create-out-tran',
  templateUrl: './create-out-tran.component.html',
  styleUrls: ['./create-out-tran.component.css']
})
export class CreateOutTranComponent implements OnInit, OnDestroy {

  //nextFolio: string = '';
  //requestedFolio: number;
  settings: PayrollId;
  transactions = {};
  transactionError: boolean = false;

  //Store the warehouse name and id
  warehouse: any = {
    id: '',
    name: '',
    productsObj: {},
  };

  //Store data for autocomplete inputs
  productsInit: any;
  inOutTypes = {};
  inOutTypesInit: any;
  prCmpas = {};
  prCmpasInit: any;
  prVntas = {};
  prVntasInit: any;

  allProducts = {};

  productType: string = 'compra';

  warehouse$: Observable<any>;

  //Forms
  createOutTranForm: FormGroup;//Main form for create
  tranProductForm: FormGroup;//Form for product modal

  modalActionsTranProduct = new EventEmitter<string|MaterializeAction>();
  modalParamsTranProduct = [{dismissible: true}];
  onEdit: number = -1;
  productsInTransaction: PrInTransaction[] = [];
  productError: boolean = false;
  
  pickadateParams = Utils.pickadateParams();

  subs: Subscription[] = [];

  constructor(
    private tranService: TranService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,

    private warehouseService: WarehouseService,
    private inAndOutService: InAndOutService,
    private productCmpaService: ProductCmpaService,
    private productVntaService: ProductVntaService,
    private productionOrderService: ProductionOrderService,
    private unitService: UnitService,
    private settingsService: CatalogsSettingsService
  ) {
    //Assign folio
    /* let setSub = this.settingsService.getPayrollSettings('1').subscribe(settings => {
      let requesteds = settings.folios.nextOutRequesteds || [];
      let lastFolio = settings.folios.nextOut;
      this.settings = settings;
      if(!this.requestedFolio){
        this.requestedFolio = lastFolio + 1;
        while(requesteds.includes(this.requestedFolio)) this.requestedFolio++;
        this.nextFolio = `S${Utils.String.fillLeft(`${this.requestedFolio}`, '0', 6)}`;
        toast(`Se apartó el folio '${this.requestedFolio}' de configuración.`, 2000);
        console.log(`Se apartó el folio '${this.requestedFolio}' de configuración.`);
        requesteds.push(this.requestedFolio);
        settings.folios.nextOutRequesteds = requesteds;
        this.settingsService.putPayrollSettings(<PayrollId>{folios: settings.folios}, '1');
      }
    });
    this.subs.push(setSub); */

    //Get name of the warehouse using the id in the URL
    this.warehouse.id = this.activatedRoute.snapshot.paramMap.get('idWare');
    this.warehouse$ = this.warehouseService.getWarehouse(this.warehouse.id);
    let subWare = this.warehouse$.subscribe(warehouse => {
      this.warehouse.productsObj = warehouse.products.reduce( (acc, cur) => {
        acc[cur.ref.path] = cur.quantity;
        return acc;
      } , {});
      this.warehouse.name = warehouse.name;
    });
    this.subs.push(subWare);

    this.productionOrders = {};
    this.subs.push(
      this.productionOrderService.getProductionOrders().subscribe(productionOrders => {
        this.rowsRead[0] = productionOrders.map(({id$, ...productionOrder}) => {
          return this.productionOrders[id$] = {id: id$, ...productionOrder}; 
        });
      })
    );
  }

  ngOnInit() {
    this.createForm();
    this.createTranProductForm();
    //Rerive data for autocomplete | InAndOut, only In
    this.subs.push(
      this.inAndOutService.getInAndOuts('out').subscribe(inOutTypes => {
        const data = inOutTypes.reduce((acc, cur) => {
          acc[`${cur.description.trim()}`] = null;
          this.allProducts[cur.id] = {...cur};
          this.inOutTypes[`${cur.description.trim()}`] = cur.id;
          return acc;
        }, {});
        this.inOutTypesInit = { 'data': data };
      })
    );
    //Rerive data for autocomplete | productCmpa
    let unitSub = this.unitService.getUnits().subscribe(units => {
      unitSub.unsubscribe();
      let unitsById: {[id: string]: UnitId} = units.reduce((acc, cur) => ({...acc, [cur.id]: cur}), {});
      this.subs.push(
        this.productCmpaService.getPrCmpas().subscribe(prCmpas => {
          const data = prCmpas.reduce((acc, cur) => {
            let characs = cur.characs.reduce((acc2, cur2, index) => `${acc2}${index ? ', ' : ''}${cur2.name.charAt(0)} ${cur2.value}`, '');
            let unitName = cur.unitRef && unitsById[cur.unitRef.id] && unitsById[cur.unitRef.id].name || '';
            cur.fullName = `${cur.name}${characs ? ` - ${characs}` : ''} - ${cur.code}${unitName ? ` - ${unitName}` : ''}`.trim();
            acc[cur.fullName] = null;
            this.allProducts[cur.id] = {...cur};
            this.prCmpas[cur.fullName] = cur.id;
            return acc;
          }, {});
          this.prCmpasInit = { "data": data };
        })
      );
    });
    //Rerive data for autocomplete | productVnta
    this.subs.push(
      this.productVntaService.getPrVntas().subscribe(prVntas => {
        const data = prVntas.reduce((acc, cur) => {
          acc[`${cur.name} - ${cur.code}`.trim()] = null;
          this.prVntas[`${cur.name} - ${cur.code}`.trim()] = cur.id;
          return acc;
        }, {});
        this.prVntasInit = { "data": data };
      })
    );
  }
  ngOnDestroy(){
    this.subs.map((sub, index) => {
      this.subs[index].unsubscribe();
    });
  }

  async onSubmit({ value } : { value: any }) {
    if(this.inOutTypes[value.inOutType] == undefined){
      this.transactionError = true;
      this.createOutTranForm.get('inOutType').reset();

    }else{
      let tran = {...value};
      if(tran.inOutType.toLowerCase().includes('ajuste') && !tran.observations) return toast('Un ajuste debe llevar observaciones.', 3000);
      tran.inOutId = this.inOutTypes[tran.inOutType];
      tran.prInTransaction = this.productsInTransaction;
      tran.warehouseId = this.warehouse.id;
      delete tran.inOutType;
      tran.folio = await this.settingsService.getNextFolioAndIncrement('nextOut');
      this.tranService.addTransaction({ ...tran }, TranType.Out);
    }
  }
  /* async returnRequested(){
    let requestedIndex = this.settings.folios.nextOutRequesteds.indexOf(this.requestedFolio);
    if(requestedIndex > -1){
      this.settings.folios.nextOutRequesteds.splice(requestedIndex, 1);
      await this.settingsService.putPayrollSettings(<PayrollId>{folios: this.settings.folios}, '1');
    }
    //this.service.windowReplace('read');
    //window.onbeforeunload = null;
  }
  updateSettings(){
    let requestedIndex = this.settings.folios.nextOutRequesteds.indexOf(this.requestedFolio);
    if(requestedIndex > -1){
      this.settings.folios.nextOutRequesteds.splice(requestedIndex, 1);
    }
    if(this.requestedFolio > this.settings.folios.nextOut) this.settings.folios.nextOut = this.requestedFolio;
    this.settingsService.putPayrollSettings(this.settings, '1');
  } */

  createForm(){
    this.createOutTranForm = this.fb.group({
      inOutType: ['', Validators.required],
      date: [this.today],
      observations: ''
    });
  }
  createTranProductForm(){
    this.tranProductForm = this.fb.group({
      productType: ['compra'],
      name: ['', Validators.required],
      quantity: ['', [Validators.required, Validators.min(0)]]
    });
  }

  openModalTranProduct(index: number) {
    this.stock = '';
    this.onEdit = index;
    this.tranProductForm.reset();
    this.productError = false;
    if (index > -1) {
      this.tranProductForm.get('quantity').setValue(-this.productsInTransaction[index].quantity);
      this.getStock(this.productsInTransaction[index].ref.path);
    }
    this.modalActionsTranProduct.emit({ action: 'modal', params: ['open'] });
    if(this.productType == 'compra'){
      this.productsInit = this.prCmpasInit;
    } else{
      this.productsInit = this.prVntasInit;
    }
  }
  closeModalTranProduct(){
    this.modalActionsTranProduct.emit({ action: 'modal', params: ['close'] });
  }
  selectPrType(productType: string){
    this.productType = productType;
    this.productsInit = (productType == 'compra') ? this.prCmpasInit : this.prVntasInit;
    this.tranProductForm.get('name').setValue('');
  }

  addPrInTransaction({ value, valid }: { value: any, valid: boolean }) {
    let [productId, collection] = this.productType == 'compra' ? [this.prCmpas[value.name], this.tranService.prCmpaCollection ] : [this.prVntas[value.name], this.tranService.prVntaCollection];
    if(!productId){
      this.productError = true;
      this.tranProductForm.get('name').reset();
    }else{
      let ref = this.tranService.afh.doc(`${collection}/${productId}`).ref;
      this.productsInTransaction.push(<any> {ref, quantity: -value.quantity} );
      this.closeModalTranProduct();
    }
  }
  editPrInTransaction({ value, valid }: { value: any, valid: boolean }, index: number){
    this.productsInTransaction[index].quantity = -value.quantity;
    this.closeModalTranProduct();
  }
  deletePrInTransaction(index){
    this.productsInTransaction.splice(index,1);
  }

  stock: string = '';
  getStock(prPath: string = ''){
    let prName: string;
    let productId: string;
    if(!prPath){
      prName = this.tranProductForm.get('name').value;
      productId = this.productType == 'compra' ? this.prCmpas[prName] : this.prVntas[prName];
    }
    if(prPath || productId){
      let productPath: string = prPath || `${this.productType == 'compra' ? this.productCmpaService.collection : this.productVntaService.collection}/${productId}`;
      this.stock = `Existencia en ${this.warehouse.name}: ${this.warehouse.productsObj[productPath] || 0}`;
    }else this.stock = '';
  }

  get today(){
    var today = new Date();
    var dd:string = today.getDate() + '';
    var mm:string = today.getMonth()+ 1 + '';
    var yyyy = today.getFullYear();
    if(+dd<10) dd = '0'+dd;
    if(+mm<10) mm = '0'+mm;
    return yyyy + '-' + mm + '-' + dd;
  }



  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 

  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  
  //ProductionOrder
  productionOrders: any = {};
  selectedProductionOrderId: string = '';


  get readValid(){ return true; }

  currentReadIndex: number;
  currentPrIndex: number;
  rowsRead = [[]];
  columnsRead = [
    [
      { title: 'Folio', name: 'name', sort: 'desc' },
      { title: 'Compromiso de entrega', name: 'deliveryDate' },
      { title: 'Cantidad', name: 'quantity' },
      { title: 'Estatus', name: 'status' }
    ]
  ]

  openModalRead(index: number, prIndex: number = -1) {
    this.currentReadIndex = index;
    this.currentPrIndex = prIndex;
    this.data = this.rowsRead[index];
    
    this.config = this.configs[index];
  
    this.onChangeTable(this.config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead({row}): any{
    if(this.currentReadIndex == 0){
      this.productsInTransaction[this.currentPrIndex].odpId = row.id;
      this.productsInTransaction[this.currentPrIndex].odpName = row.name;
    }
    this.closeModalRead();
  }
  unselectRead(){
    if(this.currentReadIndex == 0){
      this.productsInTransaction[this.currentPrIndex].odpId = '';
      this.productsInTransaction[this.currentPrIndex].odpName = '';
    }
    this.closeModalRead();
  }


  data:Array<any>;
  rows:Array<any> = [];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config;
  configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns},
    filtering: {filterString: ''}
  }));

  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

}
